// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const BomPage = lazy(() => import('./pages/BomPage'));
const WorkOrdersPage = lazy(() => import('./pages/WorkOrdersPage'));
const ProductionSchedulingPage = lazy(() => import('./pages/ProductionSchedulingPage'));
const QualityControlPage = lazy(() => import('./pages/QualityControlPage'));
const BatchTrackingPage = lazy(() => import('./pages/BatchTrackingPage'));
const YieldScrapPage = lazy(() => import('./pages/YieldScrapPage'));
const ProductionCostingPage = lazy(() => import('./pages/ProductionCostingPage'));
const MrpPage = lazy(() => import('./pages/MrpPage'));

export const ManufacturingRoutes: RouteObject = {
  path: 'manufacturing',
  element: <ModuleGuard moduleId="operations.manufacturing" />,
  children: [
    { path: 'bom', element: <BomPage />, handle: { crumb: 'BOM' } },
    { path: 'work-orders', element: <WorkOrdersPage />, handle: { crumb: 'Work Orders' } },
    { path: 'production-scheduling', element: <ProductionSchedulingPage />, handle: { crumb: 'Production Scheduling' } },
    { path: 'quality-control', element: <QualityControlPage />, handle: { crumb: 'Quality Control' } },
    { path: 'batch-tracking', element: <BatchTrackingPage />, handle: { crumb: 'Batch Tracking' } },
    { path: 'yield-scrap', element: <YieldScrapPage />, handle: { crumb: 'Yield Scrap' } },
    { path: 'production-costing', element: <ProductionCostingPage />, handle: { crumb: 'Production Costing' } },
    { path: 'mrp', element: <MrpPage />, handle: { crumb: 'MRP' } },
  ],
};
